import { render, staticRenderFns } from "./printerConfig.vue?vue&type=template&id=3185562a&"
import script from "./printerConfig.vue?vue&type=script&lang=js&"
export * from "./printerConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports